<template>
  <div class="scroll">
    <SettledHead :headType="headType" @entry="$emit('entry')" />
    <div @click.stop="handleClick($event)">
      <vue-seamless-scroll
        :data="data"
        class="items"
        :class-option="{ step: 0.5 }"
      >
        <div class="items-inner">
          <div
            v-for="(item, index) in data"
            :key="index"
            class="flex flex-1 flex-between item-content items-line pointer"
            :data-dept="item.id"
          >
            <div class="items-title ellipsis item-content" :data-dept="item.id">
              {{ item.title }}
            </div>
            <div class="items-date item-content" :data-dept="item.id">
              {{ item.date }}
            </div>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";
import SettledHead from "./SettledHead.vue";
export default {
  components: {
    vueSeamlessScroll,
    SettledHead,
  },
  props: {
    headType: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClick(e) {
      // 使仅点击按钮触发点击事件
      if (e.target.classList.contains("item-content")) {
        // item要点击的class名
        let id = e.target.dataset.dept; // 传递参数

        this.$emit("itemClick", id);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.items {
  height: 198px;
  overflow: hidden;
  &-line {
    padding: 16px 16px 0 16px;
    font-weight: 400;
    color: #333333;
    &:hover {
      color: $theme-color;
    }
  }
  &-title {
    max-width: 238px;
  }
  &-date {
    color: #999999;
  }
}

.scroll {
  background: white;
  border-radius: 12px;
  min-height: 300px;
  padding-bottom: 16px;
}
</style>
